/**
 * 语言切换
 *
 * 流程（对齐 cartsee-front 的 PRD D4 决策：切换后刷新）：
 * 1. 校验 locale
 * 2. 写入 localStorage
 * 3. 更新 vue-i18n 实例
 * 4. window.location.reload()
 */

import type { Locale } from './resolver';
import { STORAGE_KEY } from './resolver';
import { i18n, applyElementLocale } from './index';

const VALID: readonly Locale[] = ['zh-CN', 'en-US'];

export function switchLocale(newLocale: Locale): void {
  if (!VALID.includes(newLocale)) {
    throw new Error(`[i18n] Unsupported locale: ${newLocale}`);
  }
  try {
    localStorage.setItem(STORAGE_KEY, newLocale);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[i18n] Failed to persist locale:', e);
  }
  i18n.locale = newLocale;
  // 同步切换 Element-UI 内建文案 locale，保证即便后续移除 reload 也保持一致。
  applyElementLocale(newLocale);
  window.location.reload();
}
